import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "../../core/Logger.js";
import { isSome as e, disposeMaybe as i } from "../../core/maybe.js";
import { ResourceType as s } from "./enums.js";
import { bindVertexBufferLayout as r, unbindVertexBufferLayout as n } from "./Util.js";
var o = t.getLogger("esri.views.webgl.VertexArrayObject");

var f = /*#__PURE__*/function () {
  function f(t, e, i, r) {
    var n = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

    _classCallCheck(this, f);

    this._context = t, this._locations = e, this._layout = i, this._buffers = r, this._indexBuffer = n, this._glName = null, this._initialized = !1, t.instanceCounter.increment(s.VAO, this);
  }

  _createClass(f, [{
    key: "glName",
    get: function get() {
      return this._glName;
    }
  }, {
    key: "vertexBuffers",
    get: function get() {
      return this._buffers;
    }
  }, {
    key: "indexBuffer",
    get: function get() {
      return this._indexBuffer;
    }
  }, {
    key: "size",
    get: function get() {
      var _this = this;

      return Object.keys(this._buffers).reduce(function (t, e) {
        return t + _this._buffers[e].size;
      }, e(this._indexBuffer) ? this._indexBuffer.size : 0);
    }
  }, {
    key: "layout",
    get: function get() {
      return this._layout;
    }
  }, {
    key: "locations",
    get: function get() {
      return this._locations;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
      if (!this._context) return void ((this._glName || t && Object.getOwnPropertyNames(this._buffers).length > 0) && o.warn("Leaked WebGL VAO"));

      if (this._glName) {
        var e, r;

        var _t = null == (e = this._context) || null == (r = e.capabilities) ? void 0 : r.vao;

        _t ? (_t.deleteVertexArray(this._glName), this._glName = null) : o.warn("Leaked WebGL VAO");
      }

      if (this._context.getBoundVAO() === this && this._context.bindVAO(null), t) {
        for (var _t2 in this._buffers) {
          this._buffers[_t2].dispose(), delete this._buffers[_t2];
        }

        this._indexBuffer = i(this._indexBuffer);
      }

      this._context.instanceCounter.decrement(s.VAO, this), this._context = null;
    }
  }, {
    key: "initialize",
    value: function initialize() {
      if (this._initialized) return;
      var t = this._context.capabilities.vao;

      if (t) {
        var _e = t.createVertexArray();

        t.bindVertexArray(_e), this._bindLayout(), t.bindVertexArray(null), this._glName = _e;
      }

      this._initialized = !0;
    }
  }, {
    key: "bind",
    value: function bind() {
      this.initialize();
      var t = this._context.capabilities.vao;
      t ? t.bindVertexArray(this.glName) : (this._context.bindVAO(null), this._bindLayout());
    }
  }, {
    key: "_bindLayout",
    value: function _bindLayout() {
      var t = this._buffers,
          i = this._layout,
          s = this._indexBuffer;
      t || o.error("Vertex buffer dictionary is empty!");
      var n = this._context.gl;

      for (var _e2 in t) {
        var _s = t[_e2];
        _s || o.error("Vertex buffer is uninitialized!");
        var _n = i[_e2];
        _n || o.error("Vertex element descriptor is empty!"), r(this._context, this._locations, _s, _n);
      }

      if (e(s)) {
        !!this._context.capabilities.vao ? n.bindBuffer(n.ELEMENT_ARRAY_BUFFER, s.glName) : this._context.bindBuffer(s);
      }
    }
  }, {
    key: "unbind",
    value: function unbind() {
      this.initialize();
      var t = this._context.capabilities.vao;
      t ? t.bindVertexArray(null) : this._unbindLayout();
    }
  }, {
    key: "_unbindLayout",
    value: function _unbindLayout() {
      var t = this._buffers,
          i = this._layout;
      t || o.error("Vertex buffer dictionary is empty!");

      for (var _e3 in t) {
        var _s2 = t[_e3];
        _s2 || o.error("Vertex buffer is uninitialized!");
        var _r = i[_e3];
        n(this._context, this._locations, _s2, _r);
      }

      e(this._indexBuffer) && this._context.unbindBuffer(this._indexBuffer.bufferType);
    }
  }]);

  return f;
}();

export { f as default };